<div *ngIf="banners !== undefined">
    <ng-container *ngIf="banners && banners.length > 0; else paperlessBanner">
        <div class="carousel-banner-container">
            <swiper-container #swiper slides-per-view="1" [spaceBetween]="100"
                pagination='{"el":".custom-pagination", "clickable": true}'
                [autoplay]="{ delay: 10000, disableOnInteraction: true }" autoplay="true" [loop]="banners.length > 1"
                init="false">
                <swiper-slide *ngFor="let banner of banners; let index = index;">
                    <app-customer-banner [customerBannerData]="banner" [appliedContentHeight]="maxContentHeight"
                        (contentHeight)="onContentHeight($event, index)">
                    </app-customer-banner>
                </swiper-slide>
            </swiper-container>
        </div>
    </ng-container>
    <ng-template #paperlessBanner>
        <div *ngIf="showPaperLess && isAcmic; else noBanners" class="carousel-banner-container">
            <swiper-slide>
                <app-paperles-banner [isAcmic]="isAcmic"></app-paperles-banner>
            </swiper-slide>
        </div>
    </ng-template>
    <ng-template #noBanners>
        <hr class="thin-hr-mb-24" />
    </ng-template>
</div>

<div class="custom-pagination"></div>